import {useEffect, useMemo, useState} from "react";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {isOfferArchived} from "../../offer/utils/is_offer_archived";
import {fetchPropertiesDetailByIds} from "../../property/api/fetch_properties_detail_by_ids";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../property/utils/is_property_archived";
import {getLastSeenOfferProperties, LastSeenOfferPropertiesOrderType} from "../../property/utils/user_last_seen_offer_properties";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";
import {mapPropertyDetailToPersonalized} from "../utils/map_property_detail_to_personalized";

interface IPersonalizedRecentlyViewedPropertiesResult {
    recentlyViewedProperties: IPersonalizedPropertyCard[];
    recentlyViewedPropertyDetails: IPropertyDetail[];
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

const DEFAULT_RECENTLY_VIEWED_PROPERTIES_LIMIT = 8;

/**
 * Reads browsing history only after hydration and starts the dependent details
 * request from that client effect. This prevents local storage from affecting
 * the server render or the first hydration render.
 */
export const usePersonalizedRecentlyViewedProperties = (limit = DEFAULT_RECENTLY_VIEWED_PROPERTIES_LIMIT): IPersonalizedRecentlyViewedPropertiesResult => {
    const [recentlyViewedPropertyDetails, setRecentlyViewedPropertyDetails] = useState<IPropertyDetail[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const {shouldHidePrices} = useShouldHidePrices();
    const recentlyViewedProperties = useMemo(
        () => recentlyViewedPropertyDetails.map((property) => mapPropertyDetailToPersonalized(property, {shouldHidePrices})),
        [recentlyViewedPropertyDetails, shouldHidePrices]
    );

    useEffect(() => {
        let isCancelled = false;

        const fetchRecentlyViewedProperties = async () => {
            setIsLoading(true);
            setIsError(false);

            try {
                const lastSeenProperties = getLastSeenOfferProperties(undefined, LastSeenOfferPropertiesOrderType.VARIOUS_OFFER_ONLY);

                if (lastSeenProperties.length === 0) {
                    if (!isCancelled) {
                        setRecentlyViewedPropertyDetails([]);
                        setIsLoading(false);
                    }
                    return;
                }

                const response = await fetchPropertiesDetailByIds(
                    {},
                    lastSeenProperties.map((property) => property.id),
                    true
                );

                if (isCancelled) {
                    return;
                }

                const propertiesById = new Map(response.results.map((property) => [property.id, property]));
                const properties = lastSeenProperties
                    .map((lastSeenProperty) => propertiesById.get(lastSeenProperty.id))
                    .filter((property): property is IPropertyDetail => Boolean(property))
                    .filter(isAvailableProperty)
                    .slice(0, limit);

                setRecentlyViewedPropertyDetails(properties);
                setIsLoading(false);
            } catch {
                if (!isCancelled) {
                    setRecentlyViewedPropertyDetails([]);
                    setIsError(true);
                    setIsLoading(false);
                }
            }
        };

        fetchRecentlyViewedProperties();

        return () => {
            isCancelled = true;
        };
    }, [limit]);

    return {
        recentlyViewedProperties,
        recentlyViewedPropertyDetails,
        isLoading,
        isError,
        isEmpty: !isLoading && recentlyViewedProperties.length === 0
    };
};

const isAvailableProperty = (property: IPropertyDetail): boolean =>
    !isOfferArchived({
        is_active: property.offer.is_active,
        configuration: {
            limited_presentation: property.offer.configuration.limited_presentation,
            display_type: property.offer.configuration.display_type
        }
    }) && !isPropertyArchived(property);
import {useEffect, useMemo, useState} from "react";

import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {isOfferArchived} from "../../offer/utils/is_offer_archived";
import {fetchPropertiesDetailByIds} from "../../property/api/fetch_properties_detail_by_ids";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../property/utils/is_property_archived";
import {getLastSeenOfferProperties, LastSeenOfferPropertiesOrderType} from "../../property/utils/user_last_seen_offer_properties";
import {IPersonalizedPropertyCard} from "../types/IPersonalizedHomepage";
import {mapPropertyDetailToPersonalized} from "../utils/map_property_detail_to_personalized";

interface IPersonalizedRecentlyViewedPropertiesResult {
    recentlyViewedProperties: IPersonalizedPropertyCard[];
    recentlyViewedPropertyDetails: IPropertyDetail[];
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

const DEFAULT_RECENTLY_VIEWED_PROPERTIES_LIMIT = 8;

/**
 * Reads browsing history only after hydration and starts the dependent details
 * request from that client effect. This prevents local storage from affecting
 * the server render or the first hydration render.
 */
export const usePersonalizedRecentlyViewedProperties = (limit = DEFAULT_RECENTLY_VIEWED_PROPERTIES_LIMIT): IPersonalizedRecentlyViewedPropertiesResult => {
    const [recentlyViewedPropertyDetails, setRecentlyViewedPropertyDetails] = useState<IPropertyDetail[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const {shouldHidePrices} = useShouldHidePrices();
    const recentlyViewedProperties = useMemo(
        () => recentlyViewedPropertyDetails.map((property) => mapPropertyDetailToPersonalized(property, {shouldHidePrices})),
        [recentlyViewedPropertyDetails, shouldHidePrices]
    );

    useEffect(() => {
        let isCancelled = false;

        const fetchRecentlyViewedProperties = async () => {
            setIsLoading(true);
            setIsError(false);

            try {
                const lastSeenProperties = getLastSeenOfferProperties(undefined, LastSeenOfferPropertiesOrderType.VARIOUS_OFFER_ONLY);

                if (lastSeenProperties.length === 0) {
                    if (!isCancelled) {
                        setRecentlyViewedPropertyDetails([]);
                        setIsLoading(false);
                    }
                    return;
                }

                const response = await fetchPropertiesDetailByIds(
                    {},
                    lastSeenProperties.map((property) => property.id),
                    true
                );

                if (isCancelled) {
                    return;
                }

                const propertiesById = new Map(response.results.map((property) => [property.id, property]));
                const properties = lastSeenProperties
                    .map((lastSeenProperty) => propertiesById.get(lastSeenProperty.id))
                    .filter((property): property is IPropertyDetail => Boolean(property))
                    .filter(isAvailableProperty)
                    .slice(0, limit);

                setRecentlyViewedPropertyDetails(properties);
                setIsLoading(false);
            } catch {
                if (!isCancelled) {
                    setRecentlyViewedPropertyDetails([]);
                    setIsError(true);
                    setIsLoading(false);
                }
            }
        };

        fetchRecentlyViewedProperties();

        return () => {
            isCancelled = true;
        };
    }, [limit]);

    return {
        recentlyViewedProperties,
        recentlyViewedPropertyDetails,
        isLoading,
        isError,
        isEmpty: !isLoading && recentlyViewedProperties.length === 0
    };
};

const isAvailableProperty = (property: IPropertyDetail): boolean =>
    !isOfferArchived({
        is_active: property.offer.is_active,
        configuration: {
            limited_presentation: property.offer.configuration.limited_presentation,
            display_type: property.offer.configuration.display_type
        }
    }) && !isPropertyArchived(property);
